import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ece69428")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    rel: "nofollow",
    class: ['flex', 'hover:text-gray-300 rounded-md text-sm font-medium items-center text-center ' + _ctx.logoWidth + ' ' + _ctx.logoHeight + ' ' + _ctx.cssClass + ' ' + _ctx.logoPadding],
    to: _ctx.redirectLink
  }, {
    default: _withId(() => [
      _createVNode("img", {
        alt: _ctx.logoText,
        src: _ctx.logoPath,
        class: "block dark:hidden h-9 w-auto"
      }, null, 8, ["alt", "src"]),
      _createVNode("img", {
        alt: _ctx.logoText,
        src: _ctx.logoPathdark,
        class: "hidden dark:block h-9 w-auto"
      }, null, 8, ["alt", "src"]),
      _createVNode("span", {
        class: ['block lg:hidden h-8 w-auto text-gray-50 h-auto pl-1', _ctx.logoFontSize]
      }, null, 2),
      _createVNode("span", {
        class: ['hidden md:block h-8 w-auto text-gray-50 dark:text-gray-700 text-xl bolder leading-normal pl-2 h-auto', _ctx.logoFontSize],
        style: {"font-family":"Comfortaa","font-size":"2.5em","font-weight":"bolder"}
      }, _toDisplayString(_ctx.$t("nav.HeaderLogo.logoText")), 3)
    ]),
    _: 1
  }, 8, ["class", "to"]))
})